import { Badge, Typography } from '@hubii/ds-hubii'

import NotificationCard from './notification-card'
import { useOrdersProposals } from '@stores/orders-proposal.context/orders-proposal.context'
import { LoadOrdersToAnswer } from '@services/hubii/hub-service/types'

const NotificationSidebar = () => {
  const { ordersProposal } = useOrdersProposals()

  return (
    <aside className='w-60 h-screen bg-white bottom-0 right-0 min-w-64 border-l border-gray-100 flex flex-col overflow-auto overflow-x-hidden pt-3'>
      <header className='flex justify-between items-center w-full border-b border-gray-100 p-2 md:p-4'>
        <Typography variant='body1' color='textPrimary'>
          Aguardando resposta
        </Typography>
        <Badge
          dataTestId='badge'
          status='primary'
          text={ordersProposal?.data.length ?? 0}
          variant='default'
          size='small'
        />
      </header>

      {ordersProposal?.data.length ? (
        <div
          className='flex flex-col overflow-y-auto overflow-x-hidden'
          style={{ height: 'calc(100vh - 82px)' }}>
          {ordersProposal.data.map((order: LoadOrdersToAnswer.Response['data'][0]) => (
            <NotificationCard key={order.uuid} order={order} />
          ))}
        </div>
      ) : (
        <div className='flex flex-col p-2 md:p-4 text-center gap-4'>
          <Typography variant='body1'>Nenhum novo pedido</Typography>
          <Typography variant='body2' className='text-gray-500'>
            Confira se suas janelas de trabalho estão corretas.
          </Typography>
        </div>
      )}
    </aside>
  )
}

export default NotificationSidebar
